import { AdminBrandDetailsFormSocialMedia } from './admin-brand-details-form-social-media';

export class AdminBrandDetailsFormSocialMediaCollection {
  public constructor(
    public readonly items: AdminBrandDetailsFormSocialMedia[],
  ) {}
}
